// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "app" + "." + "2070a690a4e28fc7b517" + ".bundle.css";
};